export default [
  {
    key: 'popularity',
    name: 'Popularität',
    info:
      'Spotify weist jedem Song ein Popularitäts-Score zu, der darauf basiert, wie häufig ein Song abgerufen wird. Kürzlich abgespielte Songs werden dabei stärker gewichtet.',
    values: [
      { gen: 'gen_z', value: '76.14' },
      { gen: 'gen_y', value: '77.45' },
      { gen: 'gen_x', value: '75.61' },
      { gen: 'gen_boomer', value: '74.22' }
    ],
    songhigh: '6ocbgoVGwYJhOv1GgI9NsF',
    songlow: '0jAXSBY7bbgtl4oHjNSmB0',
    texthigh: 'Hohe Popularität',
    textlow: 'Niedrigere Popularität'
  },
  {
    key: 'valence',
    name: 'Fröhlichkeit',
    info: 'Songs mit einem hohen Wert tönen fröhlicher.',
    values: [
      { gen: 'gen_z', value: '0.481063' },
      { gen: 'gen_y', value: '0.488823' },
      { gen: 'gen_x', value: '0.48549' },
      { gen: 'gen_boomer', value: '0.525176' }
    ],
    songhigh: '1mqlc0vEP9mU1kZgTi6LIQ',
    songlow: '2RSHsoi04658QL5xgQVov3',
    texthigh: 'Hohe Fröhlichkeit',
    textlow: 'Niedrige Fröhlichkeit'
  },
  {
    key: 'energy',
    name: 'Energie',
    info:
      'Laute, schnelle und lärmige Songs erhalten in dieser Kategorie einen hohen Wert.',
    values: [
      { gen: 'gen_z', value: '0.64611' },
      { gen: 'gen_y', value: '0.67979' },
      { gen: 'gen_x', value: '0.64815' },
      { gen: 'gen_boomer', value: '0.61494' }
    ],
    songhigh: '2zYzyRzz6pRmhPzyfMEC8s',
    songlow: '43zdsphuZLzwA9k4DJhU0I',
    texthigh: 'Hohe Energie',
    textlow: 'Niedrige Energie'
  },
  {
    key: 'speechiness',
    name: 'Anteil Sprechgesang',
    info:
      'Dieser Wert zeigt, wie nahe ein Song an gesprochener Sprache ist. Hip-Hop erzielt entsprechend hohe Werte im Gegensatz zu gesungenen Liedern.',
    values: [
      { gen: 'gen_z', value: '0.140021' },
      { gen: 'gen_y', value: '0.105126' },
      { gen: 'gen_x', value: '0.085409' },
      { gen: 'gen_boomer', value: '0.068757' }
    ],
    songhigh: '0eKKoqxVuKTQAfzNXlCeCD',
    songlow: '0tgVpDi06FyKpA1z0VMD4v',
    texthigh: 'Hoher Sprachanteil',
    textlow: 'Niedrigere Sprachanteil'
  },
  {
    key: 'acousticness',
    name: 'Akustikanteil',
    info:
      'Je höher dieser Wert, desto stärker ist der Song von akustischen Instrumenten geprägt.',
    values: [
      { gen: 'gen_z', value: '0.233753' },
      { gen: 'gen_y', value: '0.194634' },
      { gen: 'gen_x', value: '0.220352' },
      { gen: 'gen_boomer', value: '0.268999' }
    ],
    songhigh: '4kflIGfjdZJW4ot2ioixTB',
    songlow: '6Pgkp4qUoTmJIPn7ReaGxL',
    texthigh: 'Hoher Akustikanteil',
    textlow: 'Niedriger Akustikanteil'
  },
  {
    key: 'liveness',
    name: 'Liveanteil',
    info:
      'Je höher dieser Wert, desto eher ist ein Song live vor Publikum gespielt.',
    values: [
      { gen: 'gen_z', value: '0.152749' },
      { gen: 'gen_y', value: '0.159568' },
      { gen: 'gen_x', value: '0.170865' },
      { gen: 'gen_boomer', value: '0.189081' }
    ],
    songhigh: '1oNK2oXDXWGEJLFZCPC68b',
    songlow: '4w8niZpiMy6qz1mntFA5uM',
    texthigh: 'Hoher Liveanteil',
    textlow: 'Niedriger Liveanteil'
  },
  {
    key: 'danceability',
    name: 'Tanzbarkeit',
    info:
      'Je höher dieser Wert, desto eher ist ein Song tanzbar, basierend auf einer Kombination von Tempo, Rhythmusstabilität und Regelmässigkeit des Beats.',
    values: [
      { gen: 'gen_z', value: '0.72118' },
      { gen: 'gen_y', value: '0.70667' },
      { gen: 'gen_x', value: '0.67092' },
      { gen: 'gen_boomer', value: '0.6398' }
    ],
    songhigh: '5vdp5UmvTsnMEMESIF2Ym7',
    songlow: '3TETmhGNWOcquUTtcr6RIR',
    texthigh: 'Hohe Tanzbarkeit',
    textlow: 'Niedrige Tanzbarkeit'
  },
  {
    key: 'duration_ms',
    name: 'Songdauer',
    values: [
      { gen: 'gen_z', value: '199376.9' },
      { gen: 'gen_y', value: '207583.1' },
      { gen: 'gen_x', value: '216130.3' },
      { gen: 'gen_boomer', value: '228427.7' }
    ],
    songhigh: '5CQ30WqJwcep0pYcV4AMNc',
    songlow: '4S8d14HvHb70ImctNgVzQQ',
    texthigh: 'Hohe Songdauer',
    textlow: 'Niedrige Songdauer'
  }
]
